import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { Observable } from "rxjs";
import { HttpClient, HttpParams, HttpRequest, HttpEvent } from '@angular/common/http';
import { AngularFireAuth } from '@angular/fire/auth';
import { finalize } from 'rxjs/operators';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { TranslateCompiler, TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomPopupComponent } from '../dialogs/custom-popup/custom-popup.component';

@Component({
  selector: 'app-lines',
  templateUrl: './lines.component.html',
  styleUrls: ['./lines.component.sass']
})
export class LinesComponent implements OnInit {
  linesListSubs: Subscription;
  lines: any;
  stages: any;
  grades: any;
  linesList: Line[];
  lineForm: FormGroup;
  isList: boolean = true;
  isNew: boolean = false;
  schoolsListSubs: Subscription;
  schools: any;
  modification_date: string;
  creation_date: string;
  line_name: string;
  type_accept: string;
  selectedFiles: File;

  displayedColumns: string[] = ['name', 'stage', 'grade', 'modification_date', 'actions'];
  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort, {}) sort: MatSort;

  constructor(
    public dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public firebase: AngularFireAuth,
    private http: HttpClient,
    private translate: TranslateService,
    private snackbar: MatSnackBar
  ) { }


  public getStages(schoolID: string) {
    this.linesListSubs = this.dataService
      .getStages(schoolID)
      .subscribe(res => {
        
        this.stages = res;
      },
        console.error
      );
  }

  public getGrades(schoolID: string) {
    var grade_params = {}
    grade_params['school_id'] = schoolID
    grade_params['stage_id'] = ''
    this.linesListSubs = this.dataService
      .getGrades(grade_params)
      .subscribe(res => {
        
        this.grades = res;
        //           this.usersList = res;
      },
        console.error
      );
  }

  //   public getSchools() {
  //     var params={};
  //     params['page'] = 1
  //     params['size'] = 100000
  //     params['search'] = ''
  //     this.schoolsListSubs = this.dataService
  //       .getSchools(params)
  //       .subscribe(res => {
  //         this.schools = res['items'];
  //           // ;
  // //           this.usersList = res;
  //         },
  //         console.error
  //       );
  //   }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit(): void {
    this.type_accept = '.pdf';
    this.lineForm = this.formBuilder.group({
      id: new FormControl(0, Validators.required),
      name: new FormControl('', Validators.required),
      stages: new FormControl('', Validators.required),
      grades: new FormControl('', Validators.required),
    });

    // this.schools = this.getSchools();
    // this.lines = this.getLines();

    this.route.params.subscribe(params => {
      if ((params.school_id) && (params.line_id)) {
        this.isList = false;

        this.getStages(params.school_id);
        this.getGrades(params.school_id);
        if (params.line_id != 'new') {
          this.isNew = false;
          this.linesListSubs = this.dataService
            .getLine(params.line_id) //cambiar por id en el html
            .subscribe(res => {
              this.lines = res;
              this.lineForm.controls["id"].setValue(this.lines.id);
              this.lineForm.controls["name"].setValue(this.lines.name);
              this.lineForm.controls["grades"].setValue(this.lines.grades._flat_path[1].toString());
              this.lineForm.controls["stages"].setValue(this.lines.stage._flat_path[1].toString());

              // this.value = `${environment.WEB_URL}/public/` + this.lines.id;
              this.modification_date = this.lines.modification_date;
              this.creation_date = this.lines.creation_date;
              this.line_name = this.lines.name;
            },
              console.error
            );
        }
        else {
          this.isNew = true;
        }
      }
      else {
        this.isList = true;
        if (params.id != 'new') {
          var line_params = {}
          line_params['school_id'] = params.id
          // line_params['stage'] = ''
          line_params['grade_id'] = ''
          this.dataService.getLines(line_params).subscribe(lines => {
            this.lines = lines;
            this.dataSource.data = this.lines;
          });
        }
      }
    });
  }


  goTo(lineID: string) {
    this.route.params.subscribe(params => {
      this.router.navigateByUrl(params.id + `/line/` + lineID);
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  goBack() {
    this.route.params.subscribe(params => {
      this.router.navigateByUrl('school/' + params.school_id);
    });
  }

  newLine() {
    this.route.params.subscribe(params => {
      this.router.navigateByUrl(params.id + `/line/new`);
    });
  }
  // csvInputChange(fileInputEvent: any) {
  // }


  saveLine(file: any) {
    this.route.params.subscribe(url_params => {
      var params = {};
      params['name'] = this.lineForm.controls["name"].value;
      params['id'] = this.lineForm.controls["id"].value;
      params['school'] = url_params.school_id;
      params['stage'] = this.lineForm.controls["stages"].value;
      params['grade'] = this.lineForm.controls["grades"].value;

      if (params['name'] == '') {
        this.translate.get('alerts.name_required').subscribe((res: string) => {
          // alert(res);
          this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
        })
        return false;
      }
      if (params['stage'] == '') {
        this.translate.get('alerts.stage_required').subscribe((res: string) => {
          // alert(res);
          this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
        })
        return false;
      }
      if (params['grade'] == '') {
        this.translate.get('alerts.grade_required').subscribe((res: string) => {
          // alert(res);
          this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
        })
        return false;
      }

      this.dataService.saveLine(params).subscribe(data => {
        if (data == '') {
          this.goBack()
        }
        else {
          alert(data);
        }
      })
    })
  }

  delete(id_line: string) {
    this.route.params.subscribe(url_params => {
      var params = {};
      params['name'] = '';
      params['id'] = id_line;
      params['school'] = url_params.id;


      // this.dataService.deleteLine(params).subscribe( data => {
      //   if (data == 'Line deleted'){
      //     alert(data);
      //     window.location.reload();
      //     // this.router.navigateByUrl(`school/` + params['school']);
      //   }
      //   else{
      //     alert(data);
      //   }  
      // })
    });
  }


  changeFormat() {
    if (this.lineForm.controls["type"].value == 'pdf') {
      this.type_accept = '.pdf';
    }
    else if (this.lineForm.controls["type"].value == 'img') {
      this.type_accept = '.jpeg, .png, .jpg, .svg';
    }
    else {
      this.type_accept = '.mp4, .avi, .flv, .mov, .wmv, .divx';
    }

  }
}



export class Line {
  constructor(
    public name: string,
    public type: string,
    public id: number,
    public school: string

  ) { }
}